import { API_CONFIG } from '@core/constants/config';

export interface ImageFields {
  imagePath?: string | null;
  thumbnailPath?: string | null;
  imageWidth?: number | null;
  imageHeight?: number | null;
}

export function getImageFileUrl(image?: ImageFields | null): string | null {
  return image?.imagePath
    ? `${API_CONFIG.BASE_URL}/file/${image.imagePath}`
    : null;
}

/** Thumbnail when one has been generated, otherwise the original file. */
export function getImageThumbnailUrl(
  image?: ImageFields | null
): string | null {
  return image?.thumbnailPath
    ? `${API_CONFIG.BASE_URL}/file/${image.thumbnailPath}`
    : getImageFileUrl(image);
}

export function getImageAspectRatio(
  image?: ImageFields | null
): number | undefined {
  return image?.imageWidth && image?.imageHeight
    ? image.imageWidth / image.imageHeight
    : undefined;
}
